import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { AuthGuard } from './app/shared/guards/auth.guard';
import { Notfound } from './app/pages/notfound/notfound';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppLayout,
    canActivate: [AuthGuard],
    children: [
      // { path: '', component: Dashboard },
      // { path: 'uikit', loadChildren: () => import('./app/pages/uikit/uikit.routes') },
      // { path: 'documentation', component: Documentation },
      { path: 'pages', loadChildren: () => import('./app/pages/pages.routes') },
      {
        path: 'control-panel',
        loadChildren: () =>
          import('./app/features/control-panel/control-panel.routes').then(
            (m) => m.CONTROL_PANEL_ROUTES
          ),
      },
      {
        path: 'stocks',
        loadChildren: () =>
          import('./app/features/companies/stocks.routes').then((m) => m.STOCKS_ROUTES),
      },
      {
        path: 'sectors',
        loadChildren: () =>
          import('./app/features/sectors/sectors.routes').then((m) => m.SECTORS_ROUTES),
      },
      {
        path: 'financial-statements',
        loadChildren: () =>
          import('./app/features/financial-statement/financial-statement.routes').then(
            (m) => m.FINANCIAL_STATEMENT_ROUTES
          ),
      },
      {
        path: 'users',
        loadChildren: () => import('./app/features/users/users.routes').then((m) => m.USERS_ROUTES),
      },
      {
        path: 'vouchers',
        loadChildren: () =>
          import('./app/features/vouchers/vouchers.routes').then((m) => m.VOUCHERS_ROUTES),
      },
      {
        path: 'permissions',
        loadChildren: () =>
          import('./app/features/permissions/permissions.routes').then((m) => m.PERMISSIONS_ROUTES),
      },
      {
        path: 'subscriptions',
        loadChildren: () =>
          import('./app/features/subscriptions/subscriptions.routes').then(
            (m) => m.SUBSCRIPTIONS_ROUTES
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./app/features/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
      },
      {
        path: 'audit-log',
        loadChildren: () =>
          import('./app/features/audit-log/audit-log.routes').then((m) => m.AUDIT_LOG_ROUTES),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./app/features/notifications/notifications.routes').then(
            (m) => m.NOTIFICATIONS_ROUTES,
          ),
      },
      {
        path: 'articles',
        loadChildren: () =>
          import('./app/features/articles/articles.routes').then((m) => m.ARTICLES_ROUTES),
      },
    ],
  },
  // { path: 'landing', component: Landing },
  { path: 'notfound', component: Notfound },
  {
    path: 'auth',
    loadChildren: () => import('./app/pages/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  { path: '**', redirectTo: '/notfound' },
];
